import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/shared/lib/bff/client";

export interface EventCoupon {
  label: string;
  code: string | null;
}

export async function fetchEventCoupon(eventId: string): Promise<EventCoupon> {
  return apiFetch<EventCoupon>(`/api/events/${eventId}/coupon`);
}

export const eventCouponKeys = {
  all: ["eventCoupon"] as const,
  byEvent: (eventId: string, userId: string) =>
    [...eventCouponKeys.all, eventId, userId] as const,
};

export function useEventCoupon(
  eventId: string,
  userId: string | undefined,
  enabled: boolean
) {
  return useQuery({
    queryKey: eventCouponKeys.byEvent(eventId, userId ?? ""),
    queryFn: () => fetchEventCoupon(eventId),
    enabled: Boolean(eventId && userId && enabled),
    staleTime: Infinity,
    retry: false,
  });
}
